/**
 * Converts a hex color to an RGB color.
 * @param hex - The hex color to convert, eg: `#FFFFFF`
 * @returns The RGB color, eg: `255, 255, 255`
 */
const hexToRgb = (hex: string) => {
  const cleanHex = hex.replace("#", "");

  // Parse hex values to RGB
  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);

  return `${r}, ${g}, ${b}`;
};

export { hexToRgb };
